import { Drawer } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { observer } from 'mobx-react-lite'
import { ReactElement, useCallback, useRef } from 'react'
import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'
import { Thumbnail } from '../../../ui-components/products/Thumbnail'
import styled from 'styled-components'
import { zIndex } from '../../../theme/zIndex'
import { I18n, Translate } from 'common'
import { breakpoints } from '../../../theme/breakpoints'
import { ProductModel } from 'interfaces'
import { VehicleFitment as VehicleFitmentComponent } from '../../search/Results/components/VehicleFitment'

interface IVehicleFitmentProps {
  product: ProductModel
}

export const VehicleFitmentDrawer = createNiceModal<IVehicleFitmentProps>(
  observer(({ product }): ReactElement => {
    const ref = useRef<HTMLInputElement>(null)
    const modal = useModal()

    const { lineCode, partNumber, description } = product

    // TODO: refactor into a common util or hook.
    const image = product?.partImages?.length
      ? product.partImages.find((img) => img.type === 'thumbnail')?.url
      : ''

    const handleOnClose = useCallback(() => {
      modal.remove()
    }, [modal])

    return (
      <Drawer anchor="right" open={modal.visible} onClose={handleOnClose}>
        <Container ref={ref}>
          <WrapperDivider>
            <Wrapper>
              <ImageWrapper>
                {image && (
                  <Thumbnail
                    urlOrBase64={image}
                    width={75}
                    height={75}
                    alt="brand"
                  />
                )}
              </ImageWrapper>
              <DetailsWrapper>
                <DescriptionName>{description}</DescriptionName>
                <BrandWrapper>
                  <BrandName>
                    <I18n name="partVehicleFitment"></I18n>#:&nbsp;
                  </BrandName>
                  <BrandName>
                    <b>{partNumber}</b>
                  </BrandName>
                  {lineCode && (
                    <>
                      <span>&nbsp;| &nbsp;</span>
                      <BrandName>{Translate('lineCode')}:&nbsp;</BrandName>
                      <BrandName>
                        <b> {lineCode}</b>
                      </BrandName>
                    </>
                  )}
                </BrandWrapper>
              </DetailsWrapper>
            </Wrapper>
            <StyledCloseIcon onClick={handleOnClose} />
          </WrapperDivider>
          <StyledHR />
          <VehicleFitmentComponent selectedProduct={product} />
        </Container>
      </Drawer>
    )
  })
)

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
`
const StyledHR = styled.hr`
  border-top: 1px solid #000000;
`

const Container = styled.div`
  height: 100%;
  width: 700px;
  background-color: #ffffff;
  z-index: ${zIndex.modal};
  padding: 24px;
  overflow-y: auto;
  @media screen and (max-width: ${breakpoints.laptop}px) {
    width: 400px;
  }
`
const ImageWrapper = styled.div`
  @media screen and (max-width: ${breakpoints.laptop}px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const Wrapper = styled.div`
  display: flex;
  height: 100px;
`
const WrapperDivider = styled.div`
  display: flex;
  height: 100px;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 24px;
`

const BrandWrapper = styled.div`
  display: flex;
`

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin-left: 20px;
`

const DescriptionName = styled.span`
  margin-top: 20px;
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 48px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
`

const BrandName = styled.span`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
`
